export function parseLinksFromText(
	text: string,
): { segment: string; isLink: boolean }[] {
	// The regex is not at all perfect, but should be enough for our use cases
	const linkRegex = /(https?:\/\/[^\s]+[^\s,.])/

	return text
		.split(linkRegex)
		.filter((segment) => segment !== '')
		.map((segment) => ({ segment, isLink: linkRegex.test(segment) }))
}
